<template>
<div class="container-fluid">
	<toolbar>
		<h2>
			<i class="fa fa-copy"></i>
			Quote Templates
		</h2>

		<projects-toolbar-controls 
			:show-search="false"
			:is-services="true"
			:mobile-breakpoint="900">
		</projects-toolbar-controls>
	</toolbar>

	<button class="btn btn-success" v-on:click="newTemplate">
		<i class="fa fa-plus"></i>
		New Template
	</button>

	<table-list
		record-name="Quote Template"
		:fields="fields"
		:records="mutatedTemplates"
		:has-edit="true"
		:has-delete="true"
		delete-endpoint="ServiceQuoteTemplate/delete"
		id-field="slug"
		:hide-record-count="true"
		:other-buttons="otherButtons"
		v-on:edit="editQuote"
		v-on:modelChange="fetchData"
		v-on:updatePricing="openUpdatePricingModal">
	</table-list>

	<modal-dialog :modal-visible="editModal.visible"
		modal-size="modal-lg"
		:title="editModal.title"
		:working="editModal.working"
		v-on:closeModal="editModal.visible = false"
		v-on:confirm="saveTemplate(true)">

		<section>
			<field 
				label="Quote Description (short)" 
				col-class="col-md-3" 
				v-model="editModal.payload.quote_description">
			</field>

			<field 
				label="Work to Do" 
				col-class="col-md-3" 
				v-model="editModal.payload.work_to_do" 
				:params="{type: 'richtext'}">
			</field>

			<field 
				label="Category" 
				col-class="col-md-3" 
				v-model="editModal.payload.category_id" 
				:params="{type: 'select', options: categoryOptions}">
			</field>
			
			<field 
				label="Revenue Code" 
				col-class="col-md-3" 
				v-model="editModal.payload.revenue_code_id" 
				:params="{type: 'select', options: revenueCodeOptions}">
			</field>
		</section>

		<section v-if="editModal.payload.id">
			<table-list record-name="Material"
				:fields="matFields"
				:hide-record-count="true"
				:has-delete="true"
				delete-endpoint="ServiceQuoteTemplateObject/delete"
				v-on:modelChange="fetchTemplate(editModal.template.slug)"
				:records="templateMaterials">

				<div class="d-flex justify-content-between align-items-center">
					<h3>Materials</h3>
					<div class="d-flex">
						<button class="btn btn-sm btn-success" v-on:click="addMaterials" type="button">
							<i class="fa fa-plus"></i>
						</button>
					</div>
				</div>
			</table-list>

			<table-list record-name="Equipment Type"
				:fields="equipmentTypeAndLabourFields"
				:hide-record-count="true"
				:has-delete="true"
				delete-endpoint="ServiceQuoteTemplateObject/delete"
				v-on:modelChange="fetchTemplate(editModal.template.slug)"
				:records="templateEquipmentTypes">

				<div class="d-flex justify-content-between align-items-center">
					<h3>Equipment</h3>
					<div class="d-flex">
						<button class="btn btn-sm btn-success" v-on:click="addEquipment" type="button">
							<i class="fa fa-plus"></i>
						</button>
					</div>
				</div>
			</table-list>

			<table-list record-name="Labour Item"
				:fields="equipmentTypeAndLabourFields"
				:hide-record-count="true"
				:has-delete="true"
				delete-endpoint="ServiceQuoteTemplateObject/delete"
				v-on:modelChange="fetchTemplate(editModal.template.slug)"
				:records="templateLabour">

				<div class="d-flex justify-content-between align-items-center">
					<h3>Labour</h3>
					<div class="d-flex">
						<button class="btn btn-sm btn-success" v-on:click="addLabour" type="button">
							<i class="fa fa-plus"></i>
						</button>
					</div>
				</div>
			</table-list>
		</section>
		<button v-else type="button" class="btn btn-light float-right" v-on:click="saveTemplate(false)">
			Next
			<i class="fa fa-arrow-right"></i>
		</button>
	</modal-dialog>

	<material-selector-modal :visible="materialSelectorModalVisible"
		:disable-manual="true"
		:disable-assemblies="true"
		v-on:addMaterials="confirmAddMaterials"
		v-on:closeModal="materialSelectorModalVisible = false">
	</material-selector-modal>

	<modal-dialog :modal-visible="equipmentPickerModal.visible"
		:title="equipmentPickerModal.title"
		:confirm-button-text="equipmentPickerModal.buttonText"
		:working="equipmentPickerModal.working"
		v-on:closeModal="equipmentPickerModal.visible = false"
		v-on:confirm="confirmAddEquipment">

		<form-group label="Equipment Type"
			col-class="col-md-4">
			
			<equipment-type-picker v-model="equipmentPickerModal.selectedType" :no-text-field="true"></equipment-type-picker>
		</form-group>

		<field label="Unit"
			col-class="col-md-4"
			:params="{
				type:'select',
				options:[
					{text: 'Hourly',value:'hour'},
					{text: 'Daily',value:'day'},
					{text: 'Weekly',value:'week'},
					{text: 'Monthly',value:'month'}
				]}"
			v-model="equipmentPickerModal.unit">
		</field>

		<field label="Qty"
			col-class="col-md-4"
			:params="{type:'number',min: 0,step:0.25}"
			v-model="equipmentPickerModal.qty">
		</field>
		
	</modal-dialog>

	<modal-dialog :modal-visible="labourModal.visible"
		:title="labourModal.title"
		:confirm-button-text="labourModal.buttonText"
		:working="labourModal.working"
		v-on:closeModal="labourModal.visible = false"
		v-on:confirm="confirmAddLabour">

		<field label="Charge Out Group"
			col-class="col-md-4"
			:params="{type:'select',options: chargeOutGroupOptions}"
			v-model="labourModal.group_id">
		</field>

		<field label="Hrs"
			col-class="col-md-4"
			:params="{type:'number',min: 0,step:0.25}"
			v-model="labourModal.qty">
		</field>
	</modal-dialog>

	<modal-dialog
		:modal-visible="updatePricingModal.visible"
		modal-size="modal-sm"
		title="Update Pricing"
		:working="updatePricingModal.working"
		confirm-button-text="Update"
		v-on:closeModal="updatePricingModal.visible = false"
		v-on:confirm="confirmUpdatePricing">

		Would you like to update pricing on this quote?

	</modal-dialog>
</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import ProjectsToolbarControls from "./ProjectsToolbarControls"

import InfoBox from "@/components/InfoBox"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import MaterialSelectorModal from "@/components/super_components/MaterialSelectorModal"
import EquipmentTypePicker from "@/components/super_components/EquipmentTypePicker"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

import ServiceMixins from "@/mixins/ServiceMixins.js"
import InvoiceMixins from "@/mixins/InvoiceMixins.js"

export default {
	name: "QuoteTemplates",
	components: {
		Toolbar,
		ProjectsToolbarControls,
		TableList,
		ModalDialog,
		InfoBox,
		MaterialSelectorModal,
		EquipmentTypePicker,
		FormGroup,
		Field
	},
	mixins: [ServiceMixins],
	data() {
		return {
			templates: [],
			groups: [],
			editModal: {
				visible: false,
				title: "Add New Template",
				payload: {},
				template: {},
				working: false
			},
			materialSelectorModalVisible: false,
			equipmentPickerModal: {
				title: "",
				buttonText: "Add",
				working: false,
				visible: false,
				editId: null,
				selectedType: null,
				qty: 1
			},
			labourModal: {
				title: "",
				buttonText: "Add",
				working: false,
				visible: false,
				qty: 1,
				group_id: null
			},
			updatePricingModal: {
				visible: false,
				working: false,
				template: null
			},
			otherButtons: [
				{ text: "Update Pricing", icon: "fa-dollar", click: "updatePricing", class: "btn-info" }
			],
			fields: [
				{label: "Quote Description",key: "quote_description"},
				{label: "Job Category",key: "categoryName"},
				{label: "Prices Last Updated",key: "pricesUpdated"}
				//{label: "Labour Total",key: "labourTotal",align:"right"},
				//{label: "Materials Total",key: "partsTotal",align:"right"},
				//{label: "Equipment Total",key: "equipmentTotal",align:"right"}
			],
			matFields: [
				{label: "Description",key:"description"},
				{label: "Part #",key:"part_number"},
				{label: "Qty",key:"qty",align:"right"},
				//{label: "Price",key:"price",align:"right"},
				//{label: "Per",key:"per",align:"right"},
			],
			equipmentTypeAndLabourFields: [
				{label:'Type',key:'name'},
				{label:'Qty',key:'qtyWithUnit',align:'right'},
				//{label:'Rate',key:'charge_out_rate',align:'right'}
			]
		}
	},
	computed: {
		mutatedTemplates() {
			return this.templates.map(temp => {
				if ("Category" in temp && temp.Category)
					temp.categoryName = temp.Category.name
				else
					temp.categoryName = ""

				temp.pricesUpdated = temp.prices_updated ? this.formatDateTimeToLocal(temp.prices_updated) : this.formatDateTimeToLocal(temp.created_at)

				return temp
			})
		},
		chargeOutGroupOptions() {
			return this.optionify(this.groups,"label")
		},
		templateEquipmentTypes() {
			if ("ServiceQuoteTemplateObject" in this.editModal.template && this.editModal.template.ServiceQuoteTemplateObject) {
				return this.editModal.template.ServiceQuoteTemplateObject.filter(item => "EquipmentType" in item && item.EquipmentType).map(item => {
					
					let rate = +item.EquipmentType.charge_out_rate

					item.charge_out_rate = rate.toFixed(2)
					item.name = item.EquipmentType.name
					item.qtyWithUnit = item.qty + " hours"

					if ("unit" in item) {
						item.qtyWithUnit = item.qty + " " + item.unit + "s"
					}

					return item
				})
			}
			else return []
		},
		templateMaterials() {
			if ("ServiceQuoteTemplateObject" in this.editModal.template && this.editModal.template.ServiceQuoteTemplateObject) {
				return this.editModal.template.ServiceQuoteTemplateObject.filter(item => "Material" in item && item.Material).map(item => {
					
					item.description = item.Material.description
					item.part_number = item.Material.part_number
					item.price = item.Material.material_price
					item.per = item.Material.per

					return item
				})
			}
			else return []
		},
		templateLabour() {
			if ("ServiceQuoteTemplateObject" in this.editModal.template && this.editModal.template.ServiceQuoteTemplateObject) {
				return this.editModal.template.ServiceQuoteTemplateObject.filter(item => "ClassificationGroup" in item && item.ClassificationGroup).map(item => {
					
					item.name = item.ClassificationGroup.label
					item.charge_out_rate = item.ClassificationGroup.charge_out_rate

					let unit = "hours"
					if (item.unit)
						unit = item.unit
					
					item.qtyWithUnit = item.qty + " " + unit

					return item
				})
			}
			else return []
		},	
		templateTotals() {
			let totalLabour = 0, totalEquipment = 0, totalMaterial = 0
			if ("ServiceQuoteTemplateObject" in this.editModal.template && this.editModal.template.ServiceQuoteTemplateObject) {
				this.editModal.template.ServiceQuoteTemplateObject.forEach(item => {
					if (item.Material)
						totalMaterial += +item.qty * +item.Material.material_price / item.Material.per
					else if (item.EquipmentType)
						totalEquipment += item.qty * item.EquipmentType.charge_out_rate
					else if (item.ClassificationGroup)
						totalLabour += item.qty * item.ClassificationGroup.charge_out_rate
				})
			}

			return {
				labour: totalLabour.toFixed(2),
				equipment: totalEquipment.toFixed(2),
				material: totalMaterial.toFixed(2)
			}
		}
	},
	methods: {
		newTemplate() {
			this.editModal.visible = true
			this.editModal.payload = {}
			this.editModal.template = {}
			this.editModal.title = "New Quote Template"
		},
		editQuote(quote) {
			let vm = this

			this.fetchTemplate(quote.slug).then(response => {
				vm.editModal.visible = true
				vm.editModal.title = "Edit Quote: "+response.data.quote_description

				vm.editModal.payload = response.data

				vm.$forceUpdate()

				vm.fetchQuoteData()
			})
		},
		addMaterials() {
			this.materialSelectorModalVisible = true
		},
		confirmAddMaterials(materials) {
			let vm = this

			let payload = {
				records: JSON.stringify(materials.map(record => {
					return {
						quote_template_id: vm.editModal.template.id,
						qty: record.qty,
						material_id: record.id
					}
				}))
			}

			this.postData("ServiceQuoteTemplateObject/save-batch",payload,true).then(response => {
				vm.equipmentPickerModal.working = false

				if (response.success) {
					vm.materialSelectorModalVisible = false
					vm.fetchTemplate(vm.editModal.template.slug)
				}
			})
		},
		addEquipment() {
			this.equipmentPickerModal.visible = true
			this.equipmentPickerModal.type_id = null
			this.equipmentPickerModal.qty = 1
			this.equipmentPickerModal.buttonText = "Add"
			this.equipmentPickerModal.editId = null
		},
		confirmAddEquipment() {
			let vm = this

			let payload = {
				quote_template_id: this.editModal.template.id,
				qty: this.equipmentPickerModal.qty,
				equipment_type_id: this.equipmentPickerModal.selectedType.type_id,
				unit: this.equipmentPickerModal.unit
			}

			this.equipmentPickerModal.working = true

			this.postData("ServiceQuoteTemplateObject/save",payload,true).then(response => {
				vm.equipmentPickerModal.working = false

				if (response.success) {
					vm.equipmentPickerModal.visible = false
					vm.fetchTemplate(vm.editModal.template.slug)
				}
			})
		},
		addLabour() {
			this.labourModal.visible = true
			this.labourModal.qty = 1
			this.labourModal.buttonText = "Add"

			if (this.groups.length == 0)
				this.fetchChargeOutGroups()
		},
		confirmAddLabour() {
			let vm = this

			let payload = {
				quote_template_id: this.editModal.template.id,
				qty: this.labourModal.qty,
				group_id: this.labourModal.group_id,
				unit: "hours"
			}

			this.labourModal.working = true

			this.postData("ServiceQuoteTemplateObject/save",payload,true).then(response => {
				vm.labourModal.working = false

				if (response.success) {
					vm.labourModal.visible = false
					vm.fetchTemplate(vm.editModal.template.slug)
				}
			})
		},
		saveTemplate(closeModal) {
			let vm = this
			this.editModal.working = true

			let fields = ["id","quote_description","work_to_do","category_id","revenue_code_id"]

			let payload = {}

			fields.forEach(field => {
				if (field in vm.editModal.payload)
					payload[field] = vm.editModal.payload[field]
			})

			this.postData("ServiceQuoteTemplate/save",payload,true).then(response => {
				vm.editModal.working = false
				if (response.success) {
					vm.alertSaved("Quote template saved")
					vm.fetchData()

					vm.editModal.payload.id = response.data.record_id

					if (!vm.editModal.template || !("slug" in vm.editModal.template))
						vm.fetchTemplate(response.data.slug)

					if (closeModal) 
						vm.editModal.visible = false
				}
			})
		},
		openUpdatePricingModal(template) {
			this.updatePricingModal.visible = true
			this.updatePricingModal.template = template
		},
		confirmUpdatePricing() {
			let vm = this
			this.updatePricingModal.working = true

			let slug = this.updatePricingModal.template.slug
			let params = {
				include: [{ model: "ServiceQuoteTemplateObject", include: ["Material", "EquipmentType", "ClassificationGroup"] }]
			}

			this.getJSON("ServiceQuoteTemplate/find/" + slug, params).then(templateResponse => {
				if (templateResponse.success) {
					let objects = templateResponse.data.ServiceQuoteTemplateObject || []
					let materialObjects = objects.filter(o => o.material_id > 0)
					let equipmentObjects = objects.filter(o => o.equipment_type_id > 0)
					let labourObjects = objects.filter(o => o.group_id > 0)
					let materialIds = materialObjects.map(o => o.material_id)

					let materialFetch = null
					if (materialIds.length)
						materialFetch = vm.getJSON("Material/get", { id: materialIds })

					let promises = [
						vm.getJSON("EquipmentType/get"),
						vm.getJSON("ClassificationGroup/get")
					]

					if (materialFetch)
						promises.push(materialFetch)

					Promise.all(promises).then(responses => {
						let equipmentTypes = responses[0].data || []
						let groups = responses[1].data || []
						let materials = []

						if (materialFetch)
							materials = responses[2].data || []

						let updatedRecords = []

						materialObjects.forEach(obj => {
							let material = materials.find(m => m.id == obj.material_id)
							if (material)
								updatedRecords.push({ id: obj.id, qty: obj.qty, material_price: material.material_price })
						})

						equipmentObjects.forEach(obj => {
							let equipType = equipmentTypes.find(e => e.id == obj.equipment_type_id)
							if (equipType)
								updatedRecords.push({ id: obj.id, qty: obj.qty, charge_out_rate: equipType.charge_out_rate })
						})

						labourObjects.forEach(obj => {
							let group = groups.find(g => g.id == obj.group_id)
							if (group)
								updatedRecords.push({ id: obj.id, qty: obj.qty, charge_out_rate: group.charge_out_rate })
						})

						let templatePayload = {
							id: templateResponse.data.id,
							prices_updated: vm.moment().utc().format("YYYY-MM-DD HH:mm:ss")
						}

						let savePromises = [
							vm.postData("ServiceQuoteTemplateObject/save-batch", { records: JSON.stringify(updatedRecords) }, false),
							vm.postData("ServiceQuoteTemplate/save", templatePayload, false)
						]

						Promise.all(savePromises).then(saveResponses => {
							vm.updatePricingModal.working = false

							if (saveResponses[0].success && saveResponses[1].success) {
								vm.updatePricingModal.visible = false
								vm.alertSaved("Pricing updated")
								vm.fetchData()
							}
						})
					})
				}
				vm.updatePricingModal.working = false
			})
		},
		fetchChargeOutGroups() {
			let vm = this

			this.getJSON('ClassificationGroup/get').then(response => {
				vm.groups = response.data
			})
		},
		fetchTemplate(slug) {
			let vm = this

			let params = {
				include: [
					{model: "ServiceQuoteTemplateObject",include:["Material","EquipmentType","ClassificationGroup"]}
				]
			}

			this.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("ServiceQuoteTemplate/find/"+slug,params).then(response => {
					vm.spinner(false)
					if (response.success)
						vm.editModal.template = response.data

					resolve(response)
				})
			})
		},
		fetchQuoteData() {
			let vm = this

			let promises = [
				this.fetchJobCategories(),
				this.fetchRevenueCodes()
			]

			this.spinner(true)

			Promise.all(promises).then(response => {
				vm.spinner(false)
			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let quoteTemplateParams = {
				include: [
					{
						model: "Category",
						fields: ["id","name"]
					}
				]
			}

			let promises = [
				this.getJSON("ServiceQuoteTemplate/get",quoteTemplateParams)
			]

			if (!this.$store.revenueCodes || this.$store.revenueCodes.length == 0)
				promises.push(this.fetchRevenueCodes())

			if (!this.$store.categories || this.$store.categories.length == 0)
				promises.push(this.fetchJobCategories())

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[0].success) 
					vm.templates = responses[0].data
				
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>